<template>
    <div class="d-flex flex-column">
        <el-upload class="upload-demo" ref="upload"
                   :action="action"
                   :accept="accept"
                   :file-list="fileList"
                   :on-preview="doDownload"
                   auto-upload
                   multiple
                   drag
                   :on-change="handleChange"
                   :on-remove="handleRemove"
                   :before-upload="beforeUpload">
            <el-button size="small" type="primary" icon="el-icon-plus" plain>
                文件上传 {{ fileList.length }} 个
            </el-button>
        </el-upload>
    </div>

</template>

<script>

import attachmentMixin from "@/mixin/em/common/stuffs/attachment/attachmentMixin";

export default {
    name: "MultiAttachment",
    mixins: [attachmentMixin],
    props: {
        attachmentIds: {
            type: String,
            default: ""
        },
        queryApi: {
            type: String,
            default: process.env.VUE_APP_EM_ADMIN_URL +
                "/emAttachment/getAttachmentList"
        }
    },
    data() {
        return {
            fileList: [], // 上传文件列表
            action: process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/upload",
            accept: 'application/pdf,.doc,.docx,.xls,.xlsx,.jpg, .jpeg, .png, .rar, .zip, .7z',
            loading: false
        }
    },
    watch: {
        fileList: {
            handler() {
                this.$emit('idsChanged', this.getAttachmentIds());
            }
        },
        deep: true
    },
    mounted() {
        this.getRemoteData();
    },
    methods: {
        getRemoteData() {
            if (this.attachmentIds) {
                this.$emit('loading', true);
                this.loading = true;
                let url = this.queryApi + "?attachmentIds=" + this.attachmentIds;
                this.$store.dispatch('api/get', {url: url}).then(response => {
                    if (response.length > 0) {
                        for (let item of response) {
                            this.fileList.push({
                                name: item.fileName,
                                url: process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/download?attachmentId=" + item.attachmentId,
                                response: {
                                    id: item.attachmentId
                                }
                            })
                        }
                    }
                }).finally(() => {
                    this.$emit('loading', false);
                    this.loading = false;
                });
            }
        },
        // 选择文件改变
        handleChange(files, fileList) {
            this.fileList = fileList
        },
        // 移除文件
        handleRemove(file, fileList) {
            this.fileList = fileList
        },
        beforeUpload(file) {
            const fileTypeIsValid = this.checkFileType(file.name.split(".").pop());
            if (!fileTypeIsValid) {
                this.$message.error(this.getAlertStr(-2));
            }
            const fileSizeIsLt30M = this.checkFileSize(file.size);
            if (!fileSizeIsLt30M) {
                this.$message.error(this.getAlertStr(-3));
            }
            return fileTypeIsValid && fileSizeIsLt30M;
        },
        // 下载文件
        doDownload(file) {
            let downEle = document.createElement('a');
            downEle.href = file.url;
            downEle.setAttribute('download', file.name);
            document.body.appendChild(downEle);
            downEle.click();
            downEle.remove();
        },
        getAttachmentIds() {
            let ids = [];
            for (let item of this.fileList) {
                if (item.response !== undefined) {
                    ids.push(item.response.id);
                }
            }
            return ids.join(",");
        },
    }
}
</script>

<style scoped>
.upload-demo >>> .el-upload-dragger {
    width: 100% !important;
}
</style>
